import { Box, Button, Divider, FormControl, MenuItem, Select } from '@mui/material';

import { useT } from '@/hooks';

interface TradeTabsProps {
  activeTab: 'buy' | 'sell';
  orderType: 'market' | 'limit' | 'more';
  onTabChange: (tab: 'buy' | 'sell') => void;
  onOrderTypeChange: (e: any) => void;
  onBuyTabClick: () => void;
  onSellTabClick: () => void;
  onMoreActionSelect?: (action: 'split' | 'merge') => void;
}

export function TradeTabs({
  activeTab,
  orderType,
  onTabChange,
  onOrderTypeChange,
  onBuyTabClick,
  onSellTabClick,
  onMoreActionSelect,
}: TradeTabsProps) {
  const { t } = useT();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
      <Box sx={{ display: 'flex', gap: 0 }}>
        <Button
          variant="text"
          onClick={onBuyTabClick}
          sx={{
            textTransform: 'none',
            fontWeight: activeTab === 'buy' ? 700 : 400,
            fontSize: '0.875rem',
            px: 2,
            py: 0.5,
            minWidth: 'auto',
            color: activeTab === 'buy' ? 'text.primary' : 'text.secondary',
            borderBottom: activeTab === 'buy' ? '2px solid' : '2px solid transparent',
            borderColor: activeTab === 'buy' ? 'primary.main' : 'transparent',
            borderRadius: 0,
            '&:hover': {
              bgcolor: 'transparent',
            },
          }}
        >
          {t('trade.buy', { defaultValue: 'Buy' })}
        </Button>
        <Button
          variant="text"
          onClick={onSellTabClick}
          sx={{
            textTransform: 'none',
            fontWeight: activeTab === 'sell' ? 700 : 400,
            fontSize: '0.875rem',
            px: 2,
            py: 0.5,
            minWidth: 'auto',
            color: activeTab === 'sell' ? 'text.primary' : 'text.secondary',
            borderBottom: activeTab === 'sell' ? '2px solid' : '2px solid transparent',
            borderColor: activeTab === 'sell' ? 'primary.main' : 'transparent',
            borderRadius: 0,
            '&:hover': {
              bgcolor: 'transparent',
            },
          }}
        >
          {t('trade.sell', { defaultValue: 'Sell' })}
        </Button>
      </Box>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={orderType === 'more' ? 'market' : orderType}
          onChange={onOrderTypeChange}
          sx={{
            fontSize: '0.875rem',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'divider',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'divider',
            },
          }}
        >
          <MenuItem value="market">{t('trade.market', { defaultValue: 'Market' })}</MenuItem>
          <MenuItem value="limit">{t('trade.limit', { defaultValue: 'Limit' })}</MenuItem>
          <Divider />
          {/* <MenuItem
            value="__merge__"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onMoreActionSelect?.('merge');
            }}
          >
            Merge
          </MenuItem>
          <MenuItem
            value="__split__"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onMoreActionSelect?.('split');
            }}
          >
            Split
          </MenuItem> */}
        </Select>
      </FormControl>
    </Box>
  );
}
